import { Users, UserCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface ScannerStatsProps {
  checkedIn: number;
  total: number;
}

export function ScannerStats({ checkedIn, total }: ScannerStatsProps) {
  const percentage = total > 0 ? Math.round((checkedIn / total) * 100) : 0;

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <UserCheck className="h-5 w-5 text-primary" />
            <span className="font-semibold text-foreground">Check-in Progress</span>
          </div>
          <span className="text-2xl font-bold text-primary">{percentage}%</span>
        </div>
        
        <Progress value={percentage} className="h-3 mb-3" />
        
        <div className="flex justify-between text-sm">
          <div className="flex items-center gap-1.5">
            <Users className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">Checked In:</span>
            <span className="font-semibold text-foreground">{checkedIn}</span>
          </div>
          <div className="text-muted-foreground">
            of <span className="font-semibold text-foreground">{total}</span> tickets
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
